import React, { useEffect, useState } from 'react';
import { PhoneCall, Menu, X, MapPin, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY < 10) {
        setShowBanner(true);
      } else if (currentScrollY > lastScrollY) {
        setShowBanner(false);
      }
      lastScrollY = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    name: 'About',
    href: '/about'
  }, {
    name: 'New Patient',
    href: '/new-patients'
  }, {
    name: 'Financing',
    href: '/financing'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Our Doctors',
    href: '/doctors'
  }, {
    name: 'Reviews',
    href: '/#patient-reviews'
  }, {
    name: 'Contact',
    href: '/contact'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-185">
      {/* Top Banner */}
      <motion.div initial={{
      height: 'auto',
      opacity: 1
    }} animate={{
      height: showBanner ? 'auto' : 0,
      opacity: showBanner ? 1 : 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="bg-[#225274] text-white overflow-hidden" data-id="element-186">
        <div className="py-2 px-4" data-id="element-187">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-[11px] font-bold uppercase tracking-widest gap-2" data-id="element-188">
            <div className="flex items-center gap-6 flex-wrap justify-center" data-id="element-189">
              {/* Language Toggle */}
              <div className="flex items-center bg-white/10 rounded-full px-2 py-1 gap-1" data-id="element-190">
                <button className="px-2 py-0.5 rounded-full bg-white text-[#225274] transition-colors" data-id="element-191">
                  EN
                </button>
                <button className="px-2 py-0.5 rounded-full text-white/70 hover:text-white transition-colors" data-id="element-192">
                  ES
                </button>
              </div>
              <div className="hidden sm:block w-px h-3 bg-white/20" data-id="element-193" />
              <div className="flex items-center gap-2" data-id="element-194">
                <MapPin size={12} className="text-[#54c595]" data-id="element-195" />
                <span data-id="element-196">Silver Spring, MD</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-197">
                <MapPin size={12} className="text-[#54c595]" data-id="element-198" />
                <span data-id="element-199">Baltimore, MD</span>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-2 sm:mt-0" data-id="element-200">
              <Phone size={12} className="text-[#54c595]" data-id="element-201" />
              <span data-id="element-202">Front Desk: (301) 555-0123</span>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Main Header */}
      <div className="bg-white/95 backdrop-blur-sm border-b border-slate-100" data-id="element-203">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
          <div className="flex justify-between items-center h-20" data-id="element-205">
            <a href="/" className="flex-shrink-0 flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-206">
              <img src="https://cdn.magicpatterns.com/uploads/uTWzv2J5kt8GxQJy5fAuTB/pasted-image.png" alt="Colesville Dental Center Logo" className="h-10 w-auto" data-id="element-207" />
              <span className="text-xl font-bold tracking-tight text-[#225274] hidden sm:block" data-id="element-208">
                COLESVILLE
              </span>
            </a>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex space-x-8 items-center" data-id="element-209">
              {navItems.map(item => {
              const isActive = item.href.startsWith('/#') && window.location.pathname === '/' && window.location.hash === item.href.substring(1) || item.href.startsWith('/') && !item.href.includes('#') && window.location.pathname === item.href || item.href === '/' && window.location.pathname === '/';
              return <a key={item.name} href={item.href} className={`text-sm font-medium transition-colors flex items-center gap-1.5 relative ${item.name === 'New Patient' ? 'text-[#54c595] hover:text-[#4bafbc] bg-[#cef4d2]/30 px-3 py-1.5 rounded-full border border-[#54c595]/20' : isActive ? 'text-[#225274] font-bold' : 'text-[#4F709C] hover:text-[#225274]'}`} data-id="element-210">
                    {item.name}
                    {item.name === 'New Patient' && <span className="flex h-2 w-2 rounded-full bg-[#54c595] animate-pulse" data-id="element-211" />}
                    {isActive && item.name !== 'New Patient' && <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#54c595] rounded-full" data-id="element-212" />}
                  </a>;
            })}
            </nav>

            <div className="flex items-center gap-4" data-id="element-213">
              <button onClick={() => window.location.href = '/book'} className="hidden sm:flex bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] hover:brightness-110 text-white px-6 py-3 rounded-full text-sm font-bold items-center gap-2 transition-all shadow-lg shadow-[#54c595]/20" data-id="element-214">
                <PhoneCall size={18} data-id="element-215" />
                BOOK AN APPOINTMENT
              </button>

              {/* Mobile Menu Toggle */}
              <button className="lg:hidden p-2 text-[#225274]" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-216">
                {isMenuOpen ? <X size={28} data-id="element-217" /> : <Menu size={28} data-id="element-218" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-219">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden bg-white border-b border-slate-100 shadow-xl" data-id="element-220">
            <nav className="flex flex-col p-4 space-y-4" data-id="element-221">
              {navItems.map(item => {
            const isActive = item.href.startsWith('/#') && window.location.pathname === '/' && window.location.hash === item.href.substring(1) || item.href.startsWith('/') && !item.href.includes('#') && window.location.pathname === item.href || item.href === '/' && window.location.pathname === '/';
            return <a key={item.name} href={item.href} onClick={() => setIsMenuOpen(false)} className={`text-lg font-bold py-2 border-b border-slate-50 flex items-center justify-between ${item.name === 'New Patient' ? 'text-[#54c595]' : isActive ? 'text-[#54c595]' : 'text-[#225274]'}`} data-id="element-222">
                    {item.name}
                    {item.name === 'New Patient' && <span className="text-[10px] bg-[#54c595] text-white px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-223">
                        Start Here
                      </span>}
                  </a>;
          })}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}